// const { INTERCOM_SECRET_KEY } = process.env;

// Snippet para conectar con Intercom
// @url: https://developers.intercom.com/installing-intercom/docs/basic-javascript

window.intercomSettings = {
  api_base: 'https://api-iam.intercom.io',
  app_id: process.env.VUE_APP_INTERCOM_SECRET_KEY
};

export const initializeChat = () => {
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    // eslint-disable-next-line func-names
    const i = function () {
    /* eslint-disable */
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      const l = function () {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${process.env.VUE_APP_INTERCOM_SECRET_KEY}`;
        const x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  };
